module.exports = {"title":"Credit Card Information","payWithCard":"Pay with card","name":"ShowTix4U"}


//////////////////
// WEBPACK FOOTER
// ./src/components/Common/PayWithCard/locales/en.json
// module id = 1188
// module chunks = 0